export default function UndoToast({ pendingDeletes, onUndo, onUndoAll }) {
    const size = pendingDeletes.size
    if (size === 0) return null

    const singleId = size === 1 ? Array.from(pendingDeletes.keys())[0] : null

    return (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-black text-white border-2 border-white shadow-brutal-lg px-4 py-3 flex items-center gap-4">
            <span className="text-sm">{size === 1 ? 'Item deleted.' : `${size} items deleted.`}</span>
            <button
                onClick={size === 1 ? () => onUndo(singleId) : onUndoAll}
                className="text-sm font-semibold uppercase tracking-wide underline underline-offset-2 hover:text-accent"
            >
                {size === 1 ? 'Undo' : 'Undo All'}
            </button>
        </div>
    )
}
